import { apiCall, apiFile } from '../helpers/axios';

class InvoiceService {

	static getBidNumberInvoiceUrl(auctionId, bidNumber, params) {
		return apiCall().post(`/auctions/${auctionId}/bid_number/${bidNumber}/invoice`, params, {
            responseType: 'blob',
        }).then(response => response.data);
	}

	static emailBidNumberInvoice(auctionId, bidNumber, params) {
		return apiCall().post(`/auctions/${auctionId}/bid_number/${bidNumber}/invoice`, params)
			.then(response => response.data);
	}

	static getSellerInvoiceUrl(auctionId, personId, params) {
		return apiCall().post(`/auctions/${auctionId}/seller/${personId}/invoice`, params, {
            responseType: 'blob',
        }).then(response => response.data);
	}

	static emailSellerInvoice(auctionId, personId, params) {
		return apiCall().post(`/auctions/${auctionId}/seller/${personId}/invoice`, params)
			.then(response => response.data);
	}
}

export default InvoiceService


// WEBPACK FOOTER //
// ./src/services/invoice-service.js